/** The icons following the pointer during a drag, with the refusal reason. */
import { useSyncExternalStore } from 'react';
import { CELL_H, CELL_W } from './desktop-model';
import { ItemGlyph } from './DesktopIcon';
import type { DragSession, PointerStore } from './useCanvasDrag';

export function DragGhost({ session, pointer }: { session: DragSession; pointer: PointerStore }) {
  const at = useSyncExternalStore(pointer.subscribe, pointer.get) ?? session.pointer;
  return (
    <div className="pointer-events-none fixed inset-0 z-[70]" aria-hidden>
      {session.items.slice(0, 12).map((item) => {
        const off = session.offsets.get(item.key) ?? { dc: 0, dr: 0 };
        return (
          <div
            key={item.key}
            className="absolute flex flex-col items-center gap-1 rounded-md bg-background/80 p-1.5 text-center shadow-lg ring-1 ring-border"
            style={{
              left: at.x - session.grab.dx + off.dc * CELL_W,
              top: at.y - session.grab.dy + off.dr * CELL_H,
              width: CELL_W - 8,
              opacity: session.allowed ? 0.9 : 0.6,
            }}
          >
            <ItemGlyph item={item} />
            <span className="line-clamp-2 w-full break-words text-[11px] leading-tight">
              {item.name}
            </span>
          </div>
        );
      })}
      {session.items.length > 1 && (
        <span
          className="absolute rounded-full bg-primary px-2 py-0.5 text-xs font-medium text-primary-foreground"
          style={{ left: at.x + 14, top: at.y + 14 }}
        >
          {session.items.length}
        </span>
      )}
      {!session.allowed && session.reason && (
        <span
          role="status"
          className="absolute max-w-xs rounded-md bg-popover px-2 py-1 text-xs text-popover-foreground shadow ring-1 ring-border"
          style={{ left: at.x + 16, top: at.y + 36 }}
        >
          {session.reason}
        </span>
      )}
    </div>
  );
}
